/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardVisa/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardVisa({
  children,
  viewPath = "/DesignSystem/Svgs/CreditCardVisa",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 55,
  height = 35,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#fff",
  fill3 = "#fcb316",
  fill4 = "#10357f"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CreditCardVisa.Svg"
  data-view-path={viewPath}
 viewBox="0 0 55 35"
 fillRule="evenodd"
 clipRule="evenodd"
 strokeLinejoin="round"
 strokeMiterlimit={2}
 style={{'--as-1-Zqh28J': alignSelf,'--mt-2-Zqh28J': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zqh28J': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zqh28J': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zqh28J': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zqh28J': opacity,'--w-10-Zqh28J': typeof width === 'number' ? `${width}px` : width,'--h-11-Zqh28J': typeof height === 'number' ? `${height}px` : height,'--a-7-Zqh28J': isAnimated ? animation : "none",'--sd-8-Zqh28J': isAnimated ? strokeDashoffset : 0,'--sd-9-Zqh28J': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CreditCardVisa.SvgPath"
  data-view-path={viewPath}
 d="M-142.5-20.7h288v74h-288z"
 style={{'--f-12-Zqh28J': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="CreditCardVisa.SvgPath:1"
  data-view-path={viewPath}
 d="M0 0h54.8v34.8H0z"
 style={{'--f-12-Zqh28J': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="CreditCardVisa.SvgPath:2"
  data-view-path={viewPath}
 d="M.9 29.1h53v4.7H.9z"
 style={{'--f-12-Zqh28J': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="CreditCardVisa.SvgPath:3"
  data-view-path={viewPath}
 d="M.9.9h53v4.7H.9z"
 style={{'--f-12-Zqh28J': fill4}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="CreditCardVisa.SvgPath:4"
  data-view-path={viewPath}
 d="M22.1 10.9l-5.5 13H13l-2.7-10.4c-.2-.6-.3-.9-.8-1.1-.8-.4-2.2-.9-3.3-1.1l.1-.4H12c.7 0 1.4.5 1.6 1.3l1.4 7.6 3.5-8.9h3.6zM36 19.7c0-3.4-4.8-3.6-4.7-5.2 0-.5.5-1 1.4-1.1.5-.1 1.8-.1 3.3.6l.6-2.8c-.8-.3-1.9-.6-3.2-.6-3.3 0-5.7 1.8-5.7 4.3 0 1.9 1.7 2.9 3 3.6 1.3.6 1.8 1.1 1.8 1.6 0 .9-1 1.3-2 1.3-1.7 0-2.7-.5-3.5-.8l-.6 2.9c.8.4 2.2.7 3.8.7 3.5-.1 5.8-1.8 5.8-4.5m8.9 4.2H48l-2.7-13h-2.9c-.7 0-1.2.4-1.4 1L35.9 24h3.5l.7-1.9h4.3l.5 1.8zm-3.8-4.6l1.8-4.9 1 4.9h-2.8zm-14.2-8.4l-2.8 13h-3.4l2.8-13h3.4z"
 fillRule="nonzero"
 style={{'--f-12-Zqh28J': fill4}}
 className={`views-block ${styles.SvgPath4}`}
/>
</svg>
{children}
</React.Fragment>)
}